import * as React from 'react'
import { connect } from 'react-redux'
import { getVoice } from 'features/Voices/Voices.actions'
import { IVoicesState } from 'features/Voices/Voices.reducer'
import { Voice } from './Voice'
import { showVoiceCreateModal } from 'features/Voices/VoiceCreateModal'

export interface IVoicePageContainerProps {
  params: {
    voiceId: string
  }
}

const stateToProps = (
  { voices }: { voices: IVoicesState },
  { params: { voiceId } }: IVoicePageContainerProps
) => {
  const voice = voices.byId[voiceId] || {}
  return {
    voiceId,
    voice: voice.data,
    loading: voice.loading,
  }
}

export const dispatchToProps = {
  getVoice,
  showVoiceCreateModal,
}

export const VoicePage = connect(stateToProps, dispatchToProps)(Voice) as React.SFC<
  IVoicePageContainerProps
>



// WEBPACK FOOTER //
// src/pages/Voice/Voice.container.ts